import { ApiErrorResponse } from 'src/models/interfaces/IApiError';

export async function parseApiError(response: Response): Promise<ApiErrorResponse> {
  try {
    const body = await response.json();
    return body as ApiErrorResponse;
  } catch {
    return {
      title: response.statusText || 'Error',
      status: response.status,
      traceId: '',
      path: '',
      errors: [{ code: 'UnknownError', message: `HTTP ${response.status}` }],
    };
  }
}
